import moment from 'moment';

export default {
  filterDate(date) {
    return moment(date).format('MM/DD/YYYY');
  },
  agingDate(dates) {
    const dayMiliseconds = 1000 * 60 * 60 * 24;
    const actual = new Date(dates.actual).getTime();
    const old = new Date(dates.old).getTime();
    const diff = actual - old;
    return Math.abs(Math.round(diff / dayMiliseconds));
  },
  filterTime(date) {
    return moment(date).locale('en-ca').format('LT');
  },
};
